module.exports = __webpack_public_path__ + "img/Entia-Generacion-de-energia-medio-ambiente-8.72e71c5d.webp";